import React from "react";
import Icon from "components/AppIcon";

export default function KPICard({ title, value, subtitle, trend, trendValue, icon, color, onClick }) {
  const isPositive = trend === "up";
  const isNeutral = trend === "neutral";

  return (
    <div
      className="card kpi-card-glow cursor-pointer transition-smooth-fast"
      style={{ padding: undefined }}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e?.key === "Enter" && onClick?.()}
    >
      <div className="flex items-start justify-between mb-2 sm:mb-3">
        <div
          className="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${color}18` }}
        >
          <Icon name={icon} size={16} color={color} strokeWidth={2} className="sm:hidden" />
          <Icon name={icon} size={18} color={color} strokeWidth={2} className="hidden sm:block lg:hidden" />
          <Icon name={icon} size={20} color={color} strokeWidth={2} className="hidden lg:block" />
        </div>
        {trendValue && (
          <span
            className={`font-caption text-xs font-semibold px-1.5 py-0.5 rounded-full ${
              isPositive
                ? "bg-emerald-50 text-emerald-700"
                : isNeutral
                ? "bg-gray-100 text-gray-600" :"bg-red-50 text-red-700"
            }`}
          >
            {trendValue}
          </span>
        )}
      </div>
      <div>
        <p className="font-caption font-medium mb-0.5 truncate" style={{ fontSize: '12px', color: '#475569' }}>{title}</p>
        <p className="font-heading font-bold kpi-value" style={{ color: '#0F172A' }}>{value}</p>
        {subtitle && <p className="font-caption mt-0.5 truncate" style={{ fontSize: '11px', color: '#94A3B8' }}>{subtitle}</p>}
      </div>
    </div>
  );
}